import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/instance";
import { endpoints } from "../../constants/endpoints";

export const SearchFilterAPI = createAsyncThunk(
  "SearchFilterAPI",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(endpoints.searchFilter(), data);
      return response;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);

export const ShowWorkersDetialAPI = createAsyncThunk(
  "ShowWorkersDetialAPI",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(endpoints.workerDetail(id));
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

export const popularProfessional = createAsyncThunk(
  "PopularProfessional",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(endpoints.popularProfessional(), data);
      return response;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);


export const popularProfessionalOpenSearch = createAsyncThunk(
  "PopularProfessionalOpenSearch",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(endpoints.popularProfessionalOpenSearch(), data);
      return response;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);

const initialState = {
  loading: false,
  error: false,
  results: null,
  singleWorkerResult: {},
  popularProfessionals: null,
};

const SearchFilterSlice = createSlice({
  initialState,
  name: "SearchFilterSlice",
  reducers: {
    handelResultClean: (state) => {
      state.results = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(SearchFilterAPI.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(SearchFilterAPI.fulfilled, (state, action) => {
      state.loading = false;
      state.results = Array.isArray(action?.payload?.data?.data)
        ? action?.payload?.data?.data
        : Object.values(action?.payload?.data?.data);
    });

    builder.addCase(SearchFilterAPI.rejected, (state, action) => {
      state.loading = false;
    });

    // WORKER DETAIL API
    builder.addCase(ShowWorkersDetialAPI.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(ShowWorkersDetialAPI.fulfilled, (state, action) => {
      state.loading = false;
      state.singleWorkerResult = action?.payload?.data?.data;
    });

    builder.addCase(ShowWorkersDetialAPI.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(popularProfessional.pending, (state, action) => {
      state.error = false;
      state.loading = true;
    });
    builder.addCase(popularProfessional.fulfilled, (state, action) => {
      state.error = false;
      state.loading = false;
      state.popularProfessionals = action.payload.data;
    });
    builder.addCase(popularProfessional.rejected, (state, action) => {
      state.error = false;
      state.loading = true;
    });

    builder.addCase(popularProfessionalOpenSearch.pending, (state, action) => {
      state.error = false;
      state.loading = true;
    });
    builder.addCase(popularProfessionalOpenSearch.fulfilled, (state, action) => {
      state.error = false;
      state.loading = false;
      state.popularProfessionals = action.payload.data;
    });
    builder.addCase(popularProfessionalOpenSearch.rejected, (state, action) => {
      state.error = false;
      state.loading = true;
    });
  },
});

export const { handelResultClean } = SearchFilterSlice.actions;
export default SearchFilterSlice.reducer;
